import { Repository } from "src/firebase/firestore/repository";
import { FunctionErrorAggregate } from "../types/function-error.entity";

class FunctionErrorsRepository extends Repository<FunctionErrorAggregate> {
  constructor() {
    super("function_errors");
  }
}

export const functionErrorsRepository = new FunctionErrorsRepository();
